// extracted by mini-css-extract-plugin
export default {"sectionWrapper":"Mo-z","outfitFeedbackSection":"No-z"};